/** Normalize API / STOMP timestamps to epoch milliseconds. */
export function parseEventTimestampMs(value: unknown): number | null {
  if (value == null) return null;

  if (typeof value === 'number' && Number.isFinite(value)) {
    if (value <= 0) return null;
    // Values above ~Sat Sep 09 2001 are treated as ms; smaller values as seconds.
    return value > 1_000_000_000_000 ? value : value * 1000;
  }

  if (typeof value === 'string' && value.trim()) {
    const parsed = Date.parse(value);
    if (!Number.isNaN(parsed)) return parsed;
  }

  return null;
}

/** Format a timestamp for display in India Standard Time (24h). */
export function formatTimeIst(
  epochMs: number | null | undefined,
  locale: string = 'en-IN'
): string {
  if (epochMs == null || !Number.isFinite(epochMs) || epochMs <= 0) {
    return '—';
  }

  return new Date(epochMs).toLocaleTimeString(locale, {
    timeZone: 'Asia/Kolkata',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
}

export function resolveRoundEndedAtMs(...candidates: unknown[]): number | null {
  for (const candidate of candidates) {
    const parsed = parseEventTimestampMs(candidate);
    if (parsed != null) return parsed;
  }
  return null;
}
